import React, {useState} from "react";
import Dropdown from 'react-dropdown';
import {Field} from "formik";
import css from './Select.module.scss';
import {withTranslation} from "../../../i18n";

const namespacesRequired = ['common'];

const Select = (props) => {

    const findValue = (val) => {
        const res = props.options.find(opt => opt.value == val);
        if (!res) {
            if(props.defaultValue !== undefined){
                return props.defaultValue;
            }
            return null;
        }

        return res;
    };

    const [oldValue, setOldValue] = useState(findValue(props.value));

    return (<Field name={props.inputName}
                   id={props.inputId}
    >
        {({field: {value}, form: {setFieldValue, setFieldTouched, errors}}) => (
            <div className={`${css.input__wrapper} ${props.customClass}`} ref={props.anchorRef}>
                {props.label && <label className={css.label}>
                    {props.label} {props.required && "*"}
                </label>}
                <Dropdown options={props.options}
                          onChange={(newValue) => {
                              if (!props.onChange || props.onChange(newValue, oldValue)) {
                                  setFieldValue(props.inputName, newValue.value);
                                  setFieldTouched(props.inputName, true);
                                  setOldValue(newValue);
                              }
                          }}
                          disabled={props.disabled}
                          onBlur={props.onBlur}
                          value={findValue(props.value)}
                          placeholder={props.placeholder || props.t('common:common.placeholder')}
                          className={`${css.select} ${props.customSelect}`}
                          controlClassName={`${css.select__control} ${props.customControl}`}
                          placeholderClassName={`${css.select__placeholder} ${props.customPlaceholder}`}
                          menuClassName={`${css.select__menu} ${props.customMenu}`}
                          arrowClassName={` ${css.select__arrow} ${props.customArrow}`}
                />
                {!props.hideErrors && ((props.errors || errors) && (props.errors || errors)[props.inputName]) && <div
                    className={css.input__errors}
                >
                    <p>{props.t('common:errors.' + (props.errors || errors)[props.inputName])}</p>
                </div>}
            </div>)}
    </Field>);
};

export default withTranslation(namespacesRequired)(Select);
